<script setup>
const currentYear = new Date().getFullYear()
</script>

<template>
  <div class="footer-block p-top-4 p-bottom-3 row-40-20">
    <img src="@/assets/img/ico/pixartprinting.svg" alt="Pixartprinting" />
    <p
      class="footer-text"
      v-html="$t('common.companyDetails', { year: currentYear })"
    />
    <div class="footer-links pixart-text2">
      <NuxtLink
        class="underline-animation"
        :to="$t('common.privacyLink')"
        target="_blank"
        >Privacy Policy</NuxtLink
      >
      <NuxtLink
        class="underline-animation"
        :to="$t('common.cookieLink')"
        target="_blank"
        >Cookie Policy</NuxtLink
      >
      <NuxtLink
        class="underline-animation"
        :to="$t('common.infoLegaliLink')"
        target="_blank"
      >
        {{ $t('common.informazioniLegali') }}</NuxtLink
      >
    </div>
  </div>
</template>

<style lang="scss">
@import './style.scss';
</style>
